module.exports = __webpack_public_path__ + "media/10.a8f308d1.mp3";